import React from "react";
import { Link } from "react-router-dom";
import { FaLinkedin, FaYoutube, FaInstagram, FaTwitter, FaMapMarkerAlt, FaWhatsapp, FaEnvelope } from "react-icons/fa";

const Footer = () => {
  const handleSubscribe = (event) => {
    event.preventDefault();
    // Implement your subscription logic here
    alert("Thank you for subscribing!");
  };

  return (
    <footer className="bg-gradient-to-br from-gray-900 via-black to-gray-800 text-gray-300">
      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info Section */}
          <div className="space-y-4">
            <h1 className="text-orange-500 text-2xl font-bold">Infuber</h1>
            <p className="md:text-sm text-xs uppercase text-gray-400">
              THE WORLD'S LEADING, SOCIAL-FIRST MARKETING AGENCY
            </p>
            <p className="text-orange-500 md:text-sm text-xs font-semibold">
              POWERED BY INFLUENCERS
            </p>
            {/* Contact Information */}
            <div className="space-y-2 mt-4">
              <div className="flex items-center space-x-2">
                <FaEnvelope className="text-orange-500" />
                <a href="mailto:help@infuber.com" className="md:text-sm text-xs hover:text-orange-500 transition-colors">
                  help@infuber.com
                </a>
              </div>
              <div className="flex items-center space-x-2">
                <FaWhatsapp className="text-orange-500" />
                <a href="tel:+447713709034" className="md:text-sm text-xs hover:text-orange-500 transition-colors">
                  +44 7713709034
                </a>
                
                <a href="tel:+919220174144" className="md:text-sm text-xs hover:text-orange-500 transition-colors">
                  +91 922 017 4144
                </a>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h2 className="md:text-lg text-base font-semibold mb-4 text-white">Quick Links</h2>
            <ul className="grid grid-cols-3 gap-x-6 gap-y-2 md:block md:space-y-2">
              <li>
                <Link to="/" className="md:text-sm text-xs hover:text-orange-500 transition-colors">Home</Link>
              </li>
              <li>
                <Link to="/our-story" className="md:text-sm text-xs hover:text-orange-500 transition-colors">Our Story</Link>
              </li>
              <li>
                <Link to="/our-work" className="md:text-sm text-xs hover:text-orange-500 transition-colors">What We Do</Link>
              </li>
              <li>
                <Link to="/career-page" className="md:text-sm text-xs hover:text-orange-500 transition-colors">Jobs</Link>
              </li>
              {/* <li>
                <Link to="/insights" className="md:text-sm text-xs hover:text-orange-500 transition-colors">Insights</Link>
              </li> */}
              <li>
                <Link to="/contact-details" className="md:text-sm text-xs hover:text-orange-500 transition-colors">Contact</Link>
              </li>
            </ul>
          </div>

          {/* Locations */}
          <div>
            <h2 className="md:text-lg text-base font-semibold mb-4 text-white">Our Locations</h2>
            <div className="space-y-4">
              <div>
                <h3 className="text-orange-500 font-semibold mb-2">UNITED KINGDOM</h3>
                <div className="flex items-start space-x-2">
                  <FaMapMarkerAlt className="text-orange-500 mt-1" />
                  <p className="md:text-sm text-xs">
                  Hamilton house, 8 victory place,<br />
                  london E14 8BQ, UK
                  </p>
                </div>
              </div>
              <div>
                <h3 className="text-orange-500 font-semibold mb-2">INDIA</h3>
                <div className="flex items-start space-x-2">
                  <FaMapMarkerAlt className="text-orange-500 mt-1" />
                  <p className="md:text-sm text-xs">
                  Golf Course Rd, DLF Phase 5,<br />
                  Sector 54, Gurugram, Haryana, India
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Newsletter */}
          <div>
            <h2 className="md:text-lg text-base font-semibold mb-4 text-white">Newsletter</h2>
            <p className="text-sm mb-4">Stay updated with our latest news and updates.</p>
            <form onSubmit={handleSubscribe} className="space-y-2">
              <div className="flex">
                <input
                  type="email"
                  placeholder="Enter your email..."
                  className="w-full px-2 md:px-4 py-2 md:py-3 rounded-l-md focus:outline-none text-gray-700 md:text-sm text-xs"
                  required
                />
                <button
                  type="submit"
                  className="bg-orange-500 hover:bg-orange-600 px-2 md:px-4 py-2 md:py-3 rounded-r-md transition-colors text-white md:text-sm text-xs font-medium"
                >
                  Subscribe
                </button>
              </div>
            </form>

            {/* Social Media Links */}
            <div className="mt-6">
              <h3 className="md:text-sm text-xs font-semibold mb-2 md:mb-3 text-white">Follow Us</h3>
              <div className="flex space-x-2 md:space-x-4">
                <a
                  href="https://www.linkedin.com/company/infuber/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-300 md:text-sm text-xs hover:text-orange-500 transition-colors"
                >
                  <FaLinkedin size={20} />
                </a>
                <a
                  href="https://www.youtube.com/channel/UCQhvBbMUy67OAsmynFjp_gQ"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-300 md:text-sm text-xs hover:text-orange-500 transition-colors"
                >
                  <FaYoutube size={20} />
                </a>
                <a
                  href="https://www.instagram.com/infuberoriginal/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-300 md:text-sm text-xs hover:text-orange-500 transition-colors"
                >
                  <FaInstagram size={20} />
                </a>
                <a
                  href="https://x.com/infuber"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-300 md:text-sm text-xs hover:text-orange-500 transition-colors"
                >
                  <FaTwitter size={20} />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="md:flex md:items-center md:justify-between">
            <div className="md:text-sm text-xs text-gray-400">
              <p>Copyright ©{new Date().getFullYear()} Infuber. All rights reserved.</p>
            </div>
            <div className="mt-4 md:mt-0">
              <div className="flex flex-wrap justify-center md:justify-end space-x-2 md:space-x-4 text-xs md:text-sm text-gray-400">
                <Link to="/privacy policy" className="md:text-sm text-xs hover:text-orange-500 transition-colors">
                  Privacy Policy
                </Link>
                <Link to="/privacy policy" className="md:text-sm text-xs hover:text-orange-500 transition-colors">
                  Terms of Service
                </Link>
                <Link to="/privacy policy" className="md:text-sm text-xs hover:text-orange-500 transition-colors">
                  Cookie Policy
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

